import { getPartnerDetails } from "./getPartnerDetails";

export const getPartnerName = () => {
  const partnerDetails = getPartnerDetails();
  return partnerDetails.partnerName;
};
